import {useEffect, useState} from "react";

export function useOnScreen(ref: any) {
    const [isIntersecting, setIsIntersecting] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const observer = new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting));

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        } else {
            setIsIntersecting(false);
            observer.disconnect();
        }

        return () => {
            observer.disconnect();
        };
    }, [ref, observer]);

    return isIntersecting;
}
